// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DomUtils = require("../../../shared/src/DomUtils.bs.js");
var WebEnvVars = require("../WebEnvVars.bs.js");

var deployEnv = WebEnvVars.vars.deployEnv;

var iframeStyle = {
  display: "none",
  visibility: "hidden"
};

var Styles = {
  iframeStyle: iframeStyle
};

var tagManagerScript = "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n    new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,\'script\',\'dataLayer\',\'GTM-TRCVMQ5\');\n  ";

function WebComponents_GoogleTagManager(Props) {
  if (deployEnv !== 3) {
    return null;
  } else {
    DomUtils.useScript({
          TAG: /* Script */1,
          _0: tagManagerScript
        });
    return React.createElement("noscript", undefined, React.createElement("iframe", {
                    style: iframeStyle,
                    height: "0",
                    src: "https://www.googletagmanager.com/ns.html?id=GTM-TRCVMQ5",
                    width: "0"
                  }));
  }
}

var make = WebComponents_GoogleTagManager;

exports.deployEnv = deployEnv;
exports.Styles = Styles;
exports.tagManagerScript = tagManagerScript;
exports.make = make;
/* react Not a pure module */
